"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.lookup = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fetchJsonp = _interopRequireDefault(require("fetch-jsonp"));

var _constants = require("./constants");

var lookup = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(callback) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _fetchJsonp["default"])(_constants.APP_LOCATION_URL, {
              jsonpCallbackFunction: 'callback'
            }).then(function (response) {
              return response.json();
            }).then(function (json) {
              var countryNotEmpty = (json === null || json === void 0 ? void 0 : json.country_code) !== '';
              var countryCode = countryNotEmpty ? json.country_code : _constants.DEFAULT_COUNTRY;
              callback(countryCode);
            })["catch"](function (err) {
              throw new Error(err);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function lookup(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.lookup = lookup;